import { Chip } from "@mui/material";

const STATUS_STYLES = {
  queued: {
    bgcolor: "#e3f2fd",
    color: "#1565c0",
  },
  processing: {
    bgcolor: "#fff3e0",
    color: "#e65100",
  },
  completed: {
    bgcolor: "#e8f5e9",
    color: "#1b5e20",
  },
  failed: {
    bgcolor: "#ffebee",
    color: "#c62828",
  },
};

function formatUploadLogStatus(status) {
  if (!status) return "Unknown";
  return status.charAt(0).toUpperCase() + status.slice(1);
}

/**
 * Renders the upload log's stored status (queued | processing | completed | failed).
 */
const UploadLogStatusChip = ({ status, size = "small", sx = {} }) => {
  const key = status && STATUS_STYLES[status] ? status : "failed";
  const palette = STATUS_STYLES[key] || STATUS_STYLES.failed;

  return (
    <Chip
      size={size}
      label={formatUploadLogStatus(status)}
      sx={{
        fontWeight: 600,
        fontSize: size === "small" ? "0.75rem" : undefined,
        bgcolor: palette.bgcolor,
        color: palette.color,
        border: "none",
        ...sx,
      }}
    />
  );
};

export default UploadLogStatusChip;
